<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="每日业绩" />
    <basicList
      ref="table"
      :config="basicListconfig"
      @search="searchEvent"
    >
      <template v-slot:otherOperations>
        <el-button
          size="small"
          icon="el-icon-download"
          type="primary"
          @click="handleExportAll"
        >导出</el-button>
      </template>
      <template v-slot:additionalFeatures>
        <div class="table">
          <el-table
            :data="basicListconfig.data"
            @sort-change="sortChange"
            header-cell-class-name="headerCellStyle"
            cell-class-name="cellStyle"
            style="width: 100%"
            row-key="id"
            resizable
            border
            :show-overflow-tooltip="true"
            :height="basicListconfig.height"
          >
            <el-table-column
              width="80"
              prop="id"
              label="ID"
              sortable="custom"
              fixed="left"
            />
            <el-table-column
              width="120"
              prop="work_date"
              label="工作日"
              sortable="custom"
              fixed="left"
            />
            <el-table-column
              width="120"
              prop="shop_name"
              label="门店名称"
              fixed="left"
            />
            <el-table-column
              width="120"
              prop="turnover_trade"
              label="营业额指标"
            />
            <el-table-column
              width="100"
              prop="turnover_ratio"
              label="营业额占比"
            >
              <template slot-scope="scope">
                {{ scope.row.turnover_ratio ? scope.row.turnover_ratio + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="140"
              prop="turnover_actual"
              label="营业额实际完成值"
            />
            <el-table-column
              width="120"
              prop="turnover_completion_rate"
              label="营业额完成率"
            >
              <template slot-scope="scope">
                {{ scope.row.turnover_completion_rate ? scope.row.turnover_completion_rate + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="130"
              prop="turnover_weighted_score"
              label="营业额加权得分"
            />
            <el-table-column
              width="100"
              prop="order_trade"
              label="订单指标"
            />
            <el-table-column
              width="100"
              prop="order_ratio"
              label="订单占比"
            >
              <template slot-scope="scope">
                {{ scope.row.order_ratio ? scope.row.order_ratio + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="130"
              prop="order_actual"
              label="订单实际完成值"
            />
            <el-table-column
              width="120"
              prop="order_completion_rate"
              label="订单完成率"
            >
              <template slot-scope="scope">
                {{ scope.row.order_completion_rate ? scope.row.order_completion_rate + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="120"
              prop="order_weighted_score"
              label="订单加权得分"
            />
            <el-table-column
              width="100"
              prop="sales_trade"
              label="动销指标"
            />
            <el-table-column
              width="100"
              prop="sales_ratio"
              label="动销占比"
            >
              <template slot-scope="scope">
                {{ scope.row.sales_ratio ? scope.row.sales_ratio + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="130"
              prop="sales_actual"
              label="动销实际完成值"
            />
            <el-table-column
              width="120"
              prop="sales_completion_rate"
              label="动销完成率"
            >
              <template slot-scope="scope">
                {{ scope.row.sales_completion_rate ? scope.row.sales_completion_rate + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="120"
              prop="sales_weighted_score"
              label="动销加权得分"
            />
            <el-table-column
              width="100"
              prop="def_money_trade"
              label="毛利指标"
            />
            <el-table-column
              width="100"
              prop="def_money_ratio"
              label="毛利占比"
            >
              <template slot-scope="scope">
                {{ scope.row.def_money_ratio ? scope.row.def_money_ratio + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="130"
              prop="def_money_actual"
              label="毛利实际完成值"
            />
            <el-table-column
              width="120"
              prop="def_money_completion_rate"
              label="毛利完成率"
            >
              <template slot-scope="scope">
                {{ scope.row.def_money_completion_rate ? scope.row.def_money_completion_rate + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="120"
              prop="def_money_weighted_score"
              label="毛利加权得分"
            />
            <el-table-column
              width="130"
              prop="shelf_product_trade"
              label="上架商品数量指标"
            />
            <el-table-column
              width="120"
              prop="shelf_product_ratio"
              label="上架商品数量占比"
            >
              <template slot-scope="scope">
                {{ scope.row.shelf_product_ratio ? scope.row.shelf_product_ratio + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="160"
              prop="shelf_product_actual"
              label="上架商品数量实际完成值"
            />
            <el-table-column
              width="150"
              prop="shelf_product_completion_rate"
              label="上架商品数量完成率"
            >
              <template slot-scope="scope">
                {{ scope.row.shelf_product_completion_rate ? scope.row.shelf_product_completion_rate + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="150"
              prop="shelf_product_weighted_score"
              label="上架商品数量加权得分"
            />
            <el-table-column
              width="110"
              prop="wait_replenish_trade"
              label="待补货数指标"
            />
            <el-table-column
              width="110"
              prop="wait_replenish_ratio"
              label="待补货数占比"
            >
              <template slot-scope="scope">
                {{ scope.row.wait_replenish_ratio ? scope.row.wait_replenish_ratio + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="150"
              prop="wait_replenish_actual"
              label="待补货数实际完成值"
            />
            <el-table-column
              width="140"
              prop="wait_replenish_completion_rate"
              label="待补货数完成率"
            >
              <template slot-scope="scope">
                {{ scope.row.wait_replenish_completion_rate ? scope.row.wait_replenish_completion_rate + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="140"
              prop="wait_replenish_weighted_score"
              label="待补货数加权得分"
            />
            <el-table-column
              width="100"
              prop="out_stock_trade"
              label="断货数指标"
            />
            <el-table-column
              width="100"
              prop="out_stock_ratio"
              label="断货数占比"
            >
              <template slot-scope="scope">
                {{ scope.row.out_stock_ratio ? scope.row.out_stock_ratio + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="140"
              prop="out_stock_actual"
              label="断货数实际完成值"
            />
            <el-table-column
              width="130"
              prop="out_stock_completion_rate"
              label="断货数完成率"
            >
              <template slot-scope="scope">
                {{ scope.row.out_stock_completion_rate ? scope.row.out_stock_completion_rate + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="130"
              prop="out_stock_weighted_score"
              label="断货数加权得分"
            />
            <el-table-column
              width="100"
              prop="stock_value_trade"
              label="货值率指标"
            />
            <el-table-column
              width="100"
              prop="stock_value_ratio"
              label="货值率占比"
            >
              <template slot-scope="scope">
                {{ scope.row.stock_value_ratio ? scope.row.stock_value_ratio + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="140"
              prop="stock_value_actual"
              label="货值率实际完成值"
            />
            <el-table-column
              width="130"
              prop="stock_value_completion_rate"
              label="货值率完成率"
            >
              <template slot-scope="scope">
                {{ scope.row.stock_value_completion_rate ? scope.row.stock_value_completion_rate + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="130"
              prop="stock_value_weighted_score"
              label="货值率加权得分"
            />
            <el-table-column
              width="100"
              prop="turnover_rate_trade"
              label="周转率指标"
            />
            <el-table-column
              width="100"
              prop="turnover_rate_ratio"
              label="周转率占比"
            >
              <template slot-scope="scope">
                {{ scope.row.turnover_rate_ratio ? scope.row.turnover_rate_ratio + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="140"
              prop="turnover_rate_actual"
              label="周转率实际完成值"
            />
            <el-table-column
              width="130"
              prop="turnover_rate_completion_rate"
              label="周转率完成率"
            >
              <template slot-scope="scope">
                {{ scope.row.turnover_rate_completion_rate ? scope.row.turnover_rate_completion_rate + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="130"
              prop="turnover_rate_weighted_score"
              label="周转率加权得分"
            />
            <el-table-column
              width="120"
              prop="price_update_trade"
              label="价格更新数指标"
            />
            <el-table-column
              width="120"
              prop="price_update_ratio"
              label="价格更新数占比"
            >
              <template slot-scope="scope">
                {{ scope.row.price_update_ratio ? scope.row.price_update_ratio + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="160"
              prop="price_update_actual"
              label="价格更新数实际完成值"
            />
            <el-table-column
              width="150"
              prop="price_update_completion_rate"
              label="价格更新数完成率"
            >
              <template slot-scope="scope">
                {{ scope.row.price_update_completion_rate ? scope.row.price_update_completion_rate + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="150"
              prop="price_update_weighted_score"
              label="价格更新数加权得分"
            />
            <el-table-column
              width="100"
              prop="stock_check_trade"
              label="盘库数指标"
            />
            <el-table-column
              width="100"
              prop="stock_check_ratio"
              label="盘库数占比"
            >
              <template slot-scope="scope">
                {{ scope.row.stock_check_ratio ? scope.row.stock_check_ratio + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="140"
              prop="stock_check_actual"
              label="盘库数实际完成值"
            />
            <el-table-column
              width="130"
              prop="stock_check_completion_rate"
              label="盘库数完成率"
            >
              <template slot-scope="scope">
                {{ scope.row.stock_check_completion_rate ? scope.row.stock_check_completion_rate + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="130"
              prop="stock_check_weighted_score"
              label="盘库数加权得分"
            />
            <el-table-column
              width="90"
              prop="ai_group_trade"
              label="AI群指标"
            />
            <el-table-column
              width="90"
              prop="ai_group_ratio"
              label="AI群占比"
            >
              <template slot-scope="scope">
                {{ scope.row.ai_group_ratio ? scope.row.ai_group_ratio + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="130"
              prop="ai_group_actual"
              label="AI群实际完成值"
            />
            <el-table-column
              width="120"
              prop="ai_group_completion_rate"
              label="AI群完成率"
            >
              <template slot-scope="scope">
                {{ scope.row.ai_group_completion_rate ? scope.row.ai_group_completion_rate + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="120"
              prop="ai_group_weighted_score"
              label="AI群加权得分"
            />
            <el-table-column
              width="100"
              prop="attendance_trade"
              label="考勤率指标"
            />
            <el-table-column
              width="100"
              prop="attendance_ratio"
              label="考勤率占比"
            >
              <template slot-scope="scope">
                {{ scope.row.attendance_ratio ? scope.row.attendance_ratio + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="140"
              prop="attendance_actual"
              label="考勤率实际完成值"
            />
            <el-table-column
              width="130"
              prop="attendance_completion_rate"
              label="考勤率完成率"
            >
              <template slot-scope="scope">
                {{ scope.row.attendance_completion_rate ? scope.row.attendance_completion_rate + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="130"
              prop="attendance_weighted_score"
              label="考勤率加权得分"
            />
            <el-table-column
              width="120"
              prop="all_completion_rate"
              label="综合完成度"
            >
              <template slot-scope="scope">
                {{ scope.row.all_completion_rate ? scope.row.all_completion_rate + '%' : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              width="160"
              prop="create_time"
              label="创建时间"
            />
            <el-table-column
              width="160"
              prop="update_time"
              label="更新时间"
            />
          </el-table>
          <div class="table_footer">
            <p class="table_footer_total">共{{ basicListconfig.total }}项数据</p>
            <el-pagination
              background
              @size-change="handleSizeChange"
              :page-sizes="[10, 50, 100, 500]"
              @current-change="handleCurrentChange"
              :current-page.sync="basicListconfig.searchParameters.page"
              :page-size="basicListconfig.searchParameters.limit"
              layout="sizes,prev, pager, next"
              :total="basicListconfig.total"
            />
          </div>
        </div>
      </template>
    </basicList>
  </div>
</template>

<script>
import { getSession } from "@/utils/cookie";
import { mapGetters } from "vuex";
import { getRoles } from "@/utils";
import { dailyPerformanceGetList } from "@/api/dailyPerformance";
import {
  getshoplist,
  userGetlist,
} from "@/api/basicConfiguration";

const defaultParameters = {
  page: 1,
  limit: 10,
};

export default {
  name: "dailyPerformance",
  data() {
    return {
      compId: null,
      shopId: null,
      userId: null,
      roleId: null,
      comp_level: 0,
      host: "",
      downloadUrl: "",
      // 列表组件参数
      basicListconfig: {
        table: true,
        loading: false,
        height: "calc(100vh - 290px)",
        search: [
          {
            label: "日期",
            type: "quickDate",
            key: "work_date",
          },
          {
            label: "员工",
            type: "select",
            options: [],
            key: "user_id",
          },
          {
            label: "门店",
            type: "select",
            options: [],
            key: "shop_id",
          },
        ],
        data: [],
        column: [],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
    };
  },
  created() {
    this.roleId = this.$store.getters.userRole;
    this.compId = this.$store.getters.userInfo.compId;
    this.shopId = this.$store.getters.userInfo.shopId;
    this.userId = this.$store.getters.userInfo.userId;
    this.comp_level = this.$store.getters.userInfo.comp_level;
    this.host =
      process.env.VUE_APP_BASE_API || "https://erp.zuizhenshi.cn";
    this.downloadUrl =
      this.host + "/admin/Daily_performance/export";

    // 初始化列表内容
    this.getlist();
    this.obtainDataSource();
  },
  methods: {
    // 搜索事件
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.searchParameters.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 排序事件
    sortChange({ column, prop, order }) {
      if (order) {
        this.basicListconfig.searchParameters.sort = prop;
        this.basicListconfig.searchParameters.order =
          order === "ascending" ? "asc" : "desc";
      } else {
        delete this.basicListconfig.searchParameters.sort;
        delete this.basicListconfig.searchParameters.order;
      }
      this.getlist();
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;
      this.basicListconfig.searchParameters.comp_id = JSON.parse(
        getRoles()
      ).comp_id;

      dailyPerformanceGetList(this.basicListconfig.searchParameters).then((res) => {
        if (res && res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data || [];
          this.basicListconfig.total = res.count || 0;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res ? res.msg : '获取数据失败');
        }
      }).catch((error) => {
        this.basicListconfig.loading = false;
        console.error('获取每日业绩列表失败:', error);
        this.$message.error('获取数据失败: ' + (error.message || '未知错误'));
      });
    },
    // 获取数据源
    obtainDataSource() {
      getshoplist({ status: 0, comp_id: JSON.parse(getRoles()).comp_id }).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "shop_id") {
              item.options = res.data.map((list) => {
                return {
                  label: list.name,
                  value: list.id || list.shop_id,
                };
              });
            }
            return item;
          });
        }
      });

      userGetlist({ comp_id: JSON.parse(getRoles()).comp_id, limit: 100000 }).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "user_id") {
              item.options = res.data.map((list) => {
                return {
                  label: list.name,
                  value: list.id,
                };
              });
            }
            return item;
          });
        }
      });
    },
    handleSizeChange(val) {
      this.basicListconfig.searchParameters.limit = val;
      this.getlist();
    },
    handleCurrentChange(val) {
      this.basicListconfig.searchParameters.page = val;
      this.getlist();
    },
    handleExportAll() {
      const apiBase = process.env.VUE_APP_BASE_API ? process.env.VUE_APP_BASE_API.replace(/"/g, '') : 'https://erp.zuizhenshi.cn';
      let params = `comp_id=${JSON.parse(getRoles()).comp_id}`;
      
      if (this.basicListconfig.searchParameters.work_date) {
        params += `&work_date=${this.basicListconfig.searchParameters.work_date}`;
      }
      if (this.basicListconfig.searchParameters.user_id) {
        params += `&user_id=${this.basicListconfig.searchParameters.user_id}`;
      }
      if (this.basicListconfig.searchParameters.shop_id) {
        params += `&shop_id=${this.basicListconfig.searchParameters.shop_id}`;
      }
      
      const url = `${apiBase}/admin/Daily_performance/export?${params}`;
      window.open(url, '_blank');
    },
  },
};
</script>

<style scoped>
/* 修复固定列遮挡水平滚动条导致无法拖动的问题 */
/deep/ .el-table__fixed,
/deep/ .el-table__fixed-right {
  height: auto !important;
  bottom: 10px !important;
}

/* 加深表格内滚动条颜色，使其可见 */
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
/deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #b0b7c0;
  border-radius: 5px;
}
/deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
  background-color: #7a828d;
}
/deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
  background-color: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/views/dailyPerformance/index.vue